export default "__VITE_ASSET__CPrYfiY2__"